import React, { useState } from "react";
import { Button, Col, Divider, Image, Row, Typography } from "antd";
import styles from "./Map.module.scss";
import { Title } from "../Title/Title";
import Map1 from "@assets/KPMG/Map/1.png";
import Map2 from "@assets/KPMG/Map/2.png";
import Map3 from "@assets/KPMG/Map/3.png";
import Map4 from "@assets/KPMG/Map/4.png";
import Map5 from "@assets/KPMG/Map/5.png";
import Map6 from "@assets/KPMG/Map/6.png";
import Map7 from "@assets/KPMG/Map/7.png";
import Map8 from "@assets/KPMG/Map/8.png";
import Map9 from "@assets/KPMG/Map/9.png";
import Map10 from "@assets/KPMG/Map/10.png";
import Member1 from "@assets/KPMG/Team/1.png";
import Member2 from "@assets/KPMG/Team/2.png";
import Member3 from "@assets/KPMG/Team/3.png";
import Member4 from "@assets/KPMG/Team/4.png";
import TickCircle from "@assets/KPMG/Tick.svg";
import CountUp from "react-countup";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
const defaultExpertsList: any = [
  {
    name: "Sharad Somani",
    image: Member1,
    href: "",
  },
  {
    name: "Deven Chhaya",
    image: Member3,
    href: "",
  },
  {
    name: "Wen Bin Lim",
    image: Member2,
    href: "",
  },
];
const countryList = [
  {
    name: "Thailand",
    icon: Map1,
    score: 80,
  },
  {
    name: "Malaysia",
    icon: Map2,
    score: 85,
  },
  {
    name: "Indonesia",
    icon: Map3,
    score: 75,
  },
  {
    name: "Singapore",
    icon: Map4,
    score: 90,
    expertList: defaultExpertsList,
  },
  {
    name: "Philippines",
    icon: Map5,
    score: 80,
  },
  {
    name: "Myanmar",
    icon: Map6,
    score: 85,
  },
  {
    name: "Vietnam",
    icon: Map7,
    score: 70,
  },
  {
    name: "Cambodia",
    icon: Map8,
    score: 85,
  },
  {
    name: "Laos",
    icon: Map9,
    score: 90,
  },
  {
    name: "Brunei Darussalam",
    icon: Map10,
    score: 65,
  },
];

const AsiaMap = () => {
  const navigate = useNavigate();
  const [selectedCountry, setSelectedcountry] = useState<string>("Singapore");
  const [selectedExperts, setSelectedExperts] = useState<any>(defaultExpertsList);
  const [selectedScore, setSelectedScore] = useState<number>(80);
  const [data, setData] = useState({
    percentage1: 50,
    percentage2: 38,
    currency1: 854,
    currency2: 345,
  });

  const handleClick = (country: string, score: number, item: any) => {
    setSelectedcountry(country);
    setSelectedScore(score);
    setSelectedExperts(item.expertList);
    const randomPercentage = Math.random() * 100;
    const randomPercentage2 = Math.random() * 100;
    const randomMoney = Math.floor(Math.random() * 1000) + 1;
    const randomMoney2 = Math.floor(Math.random() * 1000) + 1;

    const updatedData = {
      ...data,
      percentage1: Number(randomPercentage.toFixed(0)),
      percentage2: Number(randomPercentage2.toFixed(0)),
      currency1: Number(randomMoney.toFixed(0)),
      currency2: Number(randomMoney2.toFixed(0)),
    };
    setData(updatedData);
  };

  return (
    <div
      className="investment-hub"
      id="investment-asean"
      style={{ paddingTop: 20, paddingBottom: 20 }}
    >
      <Typography.Title level={3} style={{ color: "#fff" }}>
        Decarb Projects Across Asean
      </Typography.Title>
      <Row>
        {/* <Col lg={2}></Col> */}
        <Col lg={24} sm={24}>
          <Row gutter={[32, 32]}>
            <Col span={12}>
              <Fade direction="left" triggerOnce>
                <Row gutter={[32, 32]}>
                  {countryList &&
                    countryList.map((item: any, index: number) => {
                      return (
                        <Col span={8} key={index}>
                          <div
                            style={{
                              padding: 10,
                              background: "#F9FBFD",
                              boxShadow:
                                "0px 0px 10px -58px rgba(0, 0, 0, 0.15)",
                              borderRadius: 17,
                              position: "relative",
                              cursor: "pointer",
                              height: 130,
                              border:
                                item.name === selectedCountry
                                  ? "1px solid #FD349C"
                                  : "",
                            }}
                            onClick={() => {
                              handleClick(item.name, item.score, item);
                            }}
                          >
                            <div style={{ marginBottom: 10 }}>
                              <Typography.Text
                                className={
                                  selectedCountry === item.name
                                    ? "text"
                                    : "textSmall"
                                }
                                style={{
                                  color:
                                    selectedCountry === item.name
                                      ? "#1E49E2"
                                      : "#8B8B8B",
                                }}
                              >
                                {item.name}
                              </Typography.Text>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                height: 70,
                              }}
                            >
                              <Image
                                src={item.icon}
                                preview={false}
                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                              />
                            </div>
                            {item.name === selectedCountry && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: 12,
                                  right: 10,
                                }}
                              >
                                <Image src={TickCircle} preview={false} />
                              </div>
                            )}
                          </div>
                        </Col>
                      );
                    })}
                </Row>
              </Fade>
            </Col>
            <Col span={12}>
              <Fade direction="right" triggerOnce>
                <div>
                  <Typography.Title level={3} style={{ color: "#FFF" }}>
                    {selectedCountry}
                  </Typography.Title>
                  <div style={{ marginBottom: 20 }}>
                    <Typography.Text className="text" style={{ color: "#fff" }}>
                      The decarb projects hub will offer investors access to project
                      data and generate investible project names.
                    </Typography.Text>
                  </div>
                  <Typography.Text
                    className="textSmall"
                    style={{ color: "#fff" }}
                  >
                    A hub to support and engage investors and infra
                    owners/developers across sectors to access impact funds
                    digitally. The decarb projects hub will offer investors access to
                    project data and generate investible project names.
                  </Typography.Text>
                  <div>
                    <div
                      style={{
                        background: "#fff",
                        padding: "8px 20px",
                        textAlign: "center",
                        border: "1px solid #003087",
                        borderRadius: 24,
                        marginTop: 20,
                        marginBottom: 20,
                      }}
                    >
                      <Typography.Title
                        level={4}
                        style={{
                          color: "#003087",
                          marginBottom: 0,
                          fontSize: 18,
                          fontWeight: 500,
                        }}
                      >
                        Countries Attractiveness Score :{" "}
                        <CountUp end={selectedScore} />
                      </Typography.Title>
                    </div>
                  </div>
                  <Row gutter={[16, 16]}>
                    <Col md={12}>
                      <Typography.Title level={3} style={{ color: "#fff" }}>
                        $<CountUp end={data.currency1} />
                      </Typography.Title>
                      <p style={{ color: "#fff" }}>
                        GSDP, Current Price (2021-22 est.)
                      </p>
                    </Col>
                    <Col md={12}>
                      <Typography.Title level={3} style={{ color: "#fff" }}>
                        <CountUp end={data.percentage1} />%
                      </Typography.Title>
                      <p style={{ color: "#fff" }}>
                        GSDP, growth rate, YoY (2022-23)
                      </p>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col md={12}>
                      <Typography.Title level={3} style={{ color: "#fff" }}>
                        $<CountUp end={data.currency2} />
                      </Typography.Title>
                      <p style={{ color: "#fff" }}>
                        GSDP, per capita (2019-20)
                      </p>
                    </Col>
                    <Col md={12}>
                      <Typography.Title level={3} style={{ color: "#fff" }}>
                        <CountUp end={data.percentage2} />%
                      </Typography.Title>
                      <p style={{ color: "#fff" }}>
                        Share of renewable in energy
                      </p>
                    </Col>
                  </Row>
                  {selectedExperts && (
                    <Row>
                      <Col span={24}>
                        <Typography.Title level={4} style={{ color: "#fff" }}>
                          Country Experts
                        </Typography.Title>
                      </Col>
                      <Col span={24}>
                        <Row>
                          {selectedExperts.map(
                            (expert: any, eIndex: number) => (
                              <Col span={6} key={`expert${eIndex}`}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    textAlign: "center",
                                  }}
                                >
                                  <div style={{ marginBottom: 10 }}>
                                    <img
                                      src={expert.image}
                                      style={{
                                        width: 120,
                                        height: 120,
                                        borderRadius: 120,
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <Typography.Text
                                      style={{ fontSize: 16, color: "#fff" }}
                                    >
                                      {expert.name}
                                    </Typography.Text>
                                  </div>
                                </div>
                              </Col>
                            )
                          )}
                        </Row>
                      </Col>
                    </Row>
                  )}
                  {/* <div style={{ display: "flex", marginTop: 20 }}>
                    <div>
                      <Image
                        src="https://randomuser.me/api/portraits/men/10.jpg"
                        preview={false}
                        style={{ width: 60, height: 60, borderRadius: 60 }}
                      />
                    </div>
                    <div style={{ marginLeft: 10 }}>
                      <Typography.Text
                        className="textSmall"
                        style={{ color: "#fff" }}
                      >
                        Country Expert
                      </Typography.Text>
                      <br />
                      <Typography.Text
                        className="text"
                        style={{ color: "#fff" }}
                      >
                        John Doe
                      </Typography.Text>
                    </div>
                  </div> */}
                  <div style={{ marginTop: 40 }}>
                    <Button
                      type="primary"
                      className="btn-primary"
                      onClick={() =>
                        navigate(`/investment-hub?country=${selectedCountry}`)
                      }
                    >
                      VIEW ALL PROJECTS
                    </Button>
                  </div>
                </div>
              </Fade>
            </Col>
          </Row>
        </Col>
        {/* <Col lg={2}></Col> */}
      </Row>
    </div>
  );
};

export default AsiaMap;
